import { render, staticRenderFns } from "./jingpin.vue?vue&type=template&id=0f7b2128&scoped=true&"
import script from "./jingpin.vue?vue&type=script&lang=js&"
export * from "./jingpin.vue?vue&type=script&lang=js&"
import style0 from "./jingpin.vue?vue&type=style&index=0&id=0f7b2128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b2128",
  null
  
)

export default component.exports